import { useQuery } from '@tanstack/react-query';
import { Heart } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { PropertyScrollRow } from './PropertyScrollRow';

export function FavoritePropertiesRow() {
  const { user } = useAuth();

  const { data: favorites } = useQuery({
    queryKey: ['landing-favorites', user?.id],
    enabled: !!user,
    queryFn: async () => {
      const { data } = await supabase
        .from('favorites')
        .select('property_id, properties(*, property_images(url, is_primary))')
        .eq('user_id', user!.id)
        .order('created_at', { ascending: false })
        .limit(12);
      return ((data || []) as any).map((f: any) => f.properties).filter(Boolean);
    },
  });

  if (!user || !favorites?.length) return null;
  return <PropertyScrollRow title="Favorite Properties" icon={<Heart className="h-5 w-5 text-primary" />} properties={favorites} />;
}
